import { useEffect, useState } from 'react';
import ModalUploadFileLog from 'shared/components/uploadFileModal/uploadFileModal';
import { FileLabel } from 'shared/types/file';
import { EPC } from 'shared/types/epc';
import { fetchWithAuth } from 'shared/api/fetch-with-auth';
import { API_URL } from 'constants/index';
import { useSession } from '@clerk/clerk-react';
import FileLogTable from 'shared/components/uploadFileModal/fileLogTable';

const EPCsComponent = ({ energyPerformanceInfoId, unit, building }: any) => {
    const [epcs, setEpcs] = useState<EPC[]>([]);
    const [fileModalOpen, setFileModalOpen] = useState(false);
    const { session } = useSession();

    const fetchEpcs = async () => {
        const res = await fetchWithAuth(`${API_URL}/energy/epcs/${energyPerformanceInfoId}`, { method: 'GET'}, session)
        setEpcs(await res.json());
    }

    useEffect(() => {
        if(energyPerformanceInfoId) fetchEpcs();
    }, [energyPerformanceInfoId])

    const handleOpenAddEPCModal = () => {
        setFileModalOpen(true);
    };

    const handleFileModalClose = () => {
        setFileModalOpen(false);
    };

    const handleFileModalSave = async (fileLogData: any) => {
        const newEpc = fileLogData.customData?.epc;
        if (newEpc) {
            setEpcs([...epcs, newEpc]);
        }
        handleFileModalClose();
    };

    return (
        <>
            <div className="col-span-full mt-8 flex flex-col gap-3">
                <FileLogTable
                    acceptedLabels={[FileLabel.EPCCommon, FileLabel.EPCUnit]}
                    onUploadClick={handleOpenAddEPCModal}
                    building={building}
                    unit={unit}
                />
            </div>
            {fileModalOpen && (
                <ModalUploadFileLog
                    isOpen={fileModalOpen}
                    onClose={handleFileModalClose}
                    onSave={handleFileModalSave}
                    customLabels={unit ? [FileLabel.EPCUnit] : [FileLabel.EPCCommon]}
                    defaultFileLabel={unit ? FileLabel.EPCUnit : FileLabel.EPCCommon}
                    incomingCustomData={{ energyPerformanceInfoId }}
                    unit={unit}
                    building={building}
                />
            )}
        </>
    );
};

export default EPCsComponent;
